/*
*
* File JS componente Block Video
*
*/


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './search-bar.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const searchBar = () => {

    const searchBar = document.querySelector('.search-bar');
    if(!searchBar) return;

    const searchInput = searchBar.querySelector('.search-bar__input');
    const searchBtn = searchBar.querySelector('.search-bar__icon');
    if(!searchBtn || !searchInput) return;

    searchBtn.addEventListener('click', () => {
        searchInput.classList.toggle('open');
    });

}



export default searchBar;

//--------------------------------------------------------------------//